<script>
/**
 * ****************************************************************************
 * @description     :   Main component for MNG_Widget001
 * @created at      :   2025/08/01
 * @created by      :   daonx@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import { useWindowSize } from '@/utils/composables/useWindowSize.js';

import MNG_Widget001_Store from '@/views/move/mng_widget/MNG_Widget001/store';
import template from './template.html';
import './style.scss';

import BarChart from '@/views/common/chart/components/BarChart.vue';

export default {
    name: 'MNG_Widget001',
    setup() {
        const { windowWidth } = useWindowSize();
        return {
            windowWidth
        };
    },
    template: template,
    components: {
        BarChart
    },
    beforeCreate() {
        if (!store.hasModule('MNG_Widget001_Store')) {
            store.registerModule('MNG_Widget001_Store', MNG_Widget001_Store);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        const now = new Date();
        const currentDate = now.toISOString().slice(0, 7).replace(/-/g, '/');
        this.data.working_date_start = currentDate;
    },
    mounted() {
        this.setHeader(this.header);
    },
    unmounted() {
        this.setHeader([]);
        this.hideModalMessage();
    },
    data() {
        return {
            screenId: 'MNG_Widget001',
            rowActive: null,
            isShowPanel: true,
            yearLabel: '2025年',
            monthLabel: '6月',
            generalNotes: []
        };
    },
    watch: {},
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu']),
        ...mapState('MNG_Widget001_Store', ['data', 'listData', 'paginationData']),
        header() {
            const data = {
                title: '事故報告共有',
                topButtons: [
                    // {
                    //     title: {
                    //         text: '表示',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     icon: {
                    //         name: 'fa-solid fa-magnifying-glass',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     isShow: true,
                    //     isDisabled: false,
                    //     onClick: () => {}
                    // },
                    // {
                    //     title: {
                    //         text: '登録',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     icon: {
                    //         name: 'fa-solid fa-save',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     isShow: true,
                    //     isDisabled: false,
                    //     onClick: () => {}
                    // },
                    // {
                    //     title: {
                    //         text: '印刷',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     icon: {
                    //         name: 'fa-solid fa-print',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     isShow: true,
                    //     isDisabled: false,
                    //     onClick: this.printReport
                    // },
                    // {
                    //     title: {
                    //         text: '戻る',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     icon: {
                    //         name: 'fa-solid fa-arrow-left',
                    //         class: {},
                    //         style: {}
                    //     },
                    //     isShow: true,
                    //     isDisabled: false,
                    //     onClick: () => {
                    //         this.$router.go(-1);
                    //     }
                    // }
                ]
            };
            return data;
        },
        paddedGeneralNotes() {
            const max = 4;
            const out = (this.generalNotes || []).map((s) => String(s ?? ''));
            while (out.length < max) out.push('');
            return out.slice(0, max);
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('MNG_Widget001_Store', ['resetDataInit']),
        ...mapActions('MNG_Widget001_Store', ['actionSearch', 'getCombobox']),
        to3(v) {
            if (typeof v !== 'number' || isNaN(v)) return '0';
            return v.toLocaleString('ja-JP');
        },
        to3Decimal(v) {
            if (typeof v !== 'number' || isNaN(v)) return '0.000';
            return v.toFixed(3);
        },
        colTotal(rows, h) {
            return rows.reduce((s, r) => s + (r.values?.[h] ?? 0), 0);
        },
        tableGrand(rows) {
            return rows.reduce((s, r) => s + this.rowTotal(r), 0);
        },
        printReport() {
            this.doExportPDFAccident004();
        },
        async doExportPDFAccident004() {
            this.$refs.Template_MNG_Widget001.previewPdf();
        },
        search() {
            this.resetDataMngOrder007 = false;
            this.actionSearch({
                body: {
                    ...this.data,
                    page_no: this.paginationData.pageNo,
                    page_size: this.paginationData.pageSize
                },
                callback: () => {
                    // blur button search
                    document.querySelector('#common-search').blur();
                    this.rowActive = null;
                    if (this.isShowAccident004Detail) {
                        this.reloadDataMngOrder007 = true;
                    }
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.S001,
                        content: error.Message,
                        okText: 'OK'
                    });
                }
            });
        }
    }
};
</script>
